module.exports = __webpack_public_path__ + "img/laptop-01.f9d3ae4d.webp";